// Main entry point for the application
import './scss/style.scss';

document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('[data-slider="testimonials"]');
  if (!slider) return;

  const track = slider.querySelector('.testimonials__track');
  const slides = Array.from(slider.querySelectorAll('.testimonials__slide'));
  const dotsWrap = slider.querySelector('.testimonials__dots');
  const prevBtn = slider.querySelector('[data-slider-prev]');
  const nextBtn = slider.querySelector('[data-slider-next]');

  if (!track || slides.length === 0 || !dotsWrap) return;

  let currentIndex = 0;

  const visibleSlides = () => (window.innerWidth <= 1023 ? 1 : 2);
  const maxIndex = () => Math.max(0, slides.length - visibleSlides());

  const buildDots = () => {
    const pages = maxIndex() + 1;
    dotsWrap.innerHTML = '';
    for (let i = 0; i < pages; i += 1) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'testimonials__dot';
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dot.addEventListener('click', () => {
        currentIndex = i;
        update();
        restartAutoplay();
      });
      dotsWrap.appendChild(dot);
    }
  };

  const update = () => {
    const slideWidth = slides[0].getBoundingClientRect().width;
    const gap = 24;
    const shift = currentIndex * (slideWidth + gap);
    track.style.transform = `translateX(-${shift}px)`;

    const dots = Array.from(dotsWrap.children);
    dots.forEach((dot, idx) => {
      dot.classList.toggle('is-active', idx === currentIndex);
    });
  };

  const goNext = () => {
    currentIndex = currentIndex >= maxIndex() ? 0 : currentIndex + 1;
    update();
  };

  const goPrev = () => {
    currentIndex = currentIndex <= 0 ? maxIndex() : currentIndex - 1;
    update();
  };

  prevBtn?.addEventListener('click', () => {
    goPrev();
    restartAutoplay();
  });

  nextBtn?.addEventListener('click', () => {
    goNext();
    restartAutoplay();
  });

  let autoplayId = null;
  const startAutoplay = () => {
    autoplayId = window.setInterval(goNext, 3500);
  };

  const restartAutoplay = () => {
    if (autoplayId) clearInterval(autoplayId);
    startAutoplay();
  };

  buildDots();
  update();
  startAutoplay();

  window.addEventListener('resize', () => {
    currentIndex = Math.min(currentIndex, maxIndex());
    buildDots();
    update();
  });
});
